var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,"h:mmA MMM D, YYYY")))]),_c('div',{staticClass:"build"},[_vm._v("Build: "+_vm._s(_vm.version.build))])])}
var staticRenderFns = []

export { render, staticRenderFns }